// The Role Management guide (19_RoleManagement.jsx · ModuleHelp, Max 01/11).
const en = {
  createT: 'Create a role',
  createB: 'Type a name (and a description if you like) and add the role. It starts empty; tick its features in the matrix below.',
  toolsT: 'Narrow the matrix',
  toolsB: 'Pick which roles to show, search a feature by name, and collapse or expand the groups so you can find the row you want.',
  roleT: 'One column per role',
  roleB: 'Each role shows how many users hold it. The pencil edits its name or active state, the copy icon duplicates it with all its grants, and the bin deletes a role nobody uses.',
  cellT: 'View and Edit',
  cellB: 'Tick View to give the role the screen, and Edit where the screen has it to allow changes. A tick on a parent does not carry down to its sub-permissions.',
  noteT: 'Before you delete',
  noteB: 'Built-in roles can be edited but not deleted, and a role in use stays until its users are moved. Changes apply the next time a person loads the portal.',
};
const ko = {
  createT: '역할 만들기',
  createB: '이름(필요하면 설명도)을 입력하고 역할을 추가합니다. 처음에는 비어 있으니 아래 표에서 기능을 체크하세요.',
  toolsT: '표 좁혀 보기',
  toolsB: '표시할 역할을 고르고, 기능 이름으로 검색하고, 그룹을 접거나 펼쳐 원하는 행을 찾을 수 있습니다.',
  roleT: '역할별 한 열',
  roleB: '각 역할의 사용자 수가 표시됩니다. 연필은 이름과 활성 상태를 수정하고, 복사 아이콘은 모든 권한과 함께 복제하며, 휴지통은 사용자가 없는 역할을 삭제합니다.',
  cellT: 'View와 Edit',
  cellB: '화면을 쓰게 하려면 View를, 화면에 있는 경우 변경을 허용하려면 Edit를 체크합니다. 상위 기능의 체크는 하위 권한으로 내려가지 않습니다.',
  noteT: '삭제 전에',
  noteB: '기본 역할은 수정만 되고 삭제되지 않으며, 사용 중인 역할은 사용자를 옮기기 전까지 삭제할 수 없습니다. 변경은 사용자가 다음에 포털을 열 때 적용됩니다.',
};
const vi = {
  createT: 'Tạo một role',
  createB: 'Nhập tên (và mô tả nếu muốn) rồi thêm role. Role mới còn trống; hãy tick các chức năng của nó trong bảng bên dưới.',
  toolsT: 'Thu hẹp bảng',
  toolsB: 'Chọn role cần hiển thị, tìm chức năng theo tên, và thu gọn hoặc mở rộng các nhóm để tìm đúng dòng bạn cần.',
  roleT: 'Mỗi role một cột',
  roleB: 'Mỗi role cho biết có bao nhiêu người đang dùng. Cây bút sửa tên hoặc trạng thái, biểu tượng sao chép nhân bản role cùng mọi quyền, thùng rác xóa role không còn ai dùng.',
  cellT: 'View và Edit',
  cellB: 'Tick View để role được vào màn hình, và Edit (nếu màn hình có) để cho phép thay đổi. Quyền của mục cha không tự áp xuống các quyền con.',
  noteT: 'Trước khi xóa',
  noteB: 'Role có sẵn chỉ sửa được, không xóa được; role đang có người dùng thì chỉ xóa được sau khi chuyển người đó sang role khác. Thay đổi có hiệu lực vào lần tiếp theo người dùng mở portal.',
};
const zh = {
  createT: '创建角色',
  createB: '输入名称（可加说明）后添加角色。新角色一开始是空的，请在下方矩阵中勾选它的功能。',
  toolsT: '缩小矩阵范围',
  toolsB: '选择要显示的角色，按名称搜索功能，并折叠或展开分组，方便找到所需的行。',
  roleT: '每个角色一列',
  roleB: '每个角色会显示有多少用户。铅笔用于修改名称或启用状态，复制图标会连同所有权限复制该角色，垃圾桶用于删除没人使用的角色。',
  cellT: 'View 和 Edit',
  cellB: '勾选 View 让角色可以进入该页面，页面支持修改时再勾选 Edit。上级功能的勾选不会自动应用到下级权限。',
  noteT: '删除之前',
  noteB: '内置角色只能编辑不能删除，正在使用的角色要先把其用户调到别的角色才能删除。修改会在用户下次打开门户时生效。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "createT": "Créer un rôle",
  "createB": "Saisissez un nom (et une description si vous le souhaitez) et ajoutez le rôle. Il démarre vide ; cochez ses fonctionnalités dans la matrice ci-dessous.",
  "toolsT": "Affiner la matrice",
  "toolsB": "Choisissez les rôles à afficher, recherchez une fonctionnalité par son nom, et réduisez ou développez les groupes pour trouver la ligne voulue.",
  "roleT": "Une colonne par rôle",
  "roleB": "Chaque rôle indique combien d'utilisateurs le détiennent. Le crayon modifie son nom ou son état actif, l'icône de copie le duplique avec toutes ses autorisations, et la corbeille supprime un rôle que personne n'utilise.",
  "cellT": "Voir et modifier",
  "cellB": "Cochez Consulter pour donner l'écran au rôle, et Modifier, là où l'écran le propose, pour autoriser les modifications. Une coche sur un parent ne se propage pas à ses sous-autorisations.",
  "noteT": "Avant de supprimer",
  "noteB": "Les rôles intégrés peuvent être modifiés mais pas supprimés, et un rôle en cours d'utilisation reste tant que ses utilisateurs n'ont pas été déplacés. Les modifications s'appliquent au prochain chargement du portail par la personne."
};
const ja = {
  "createT": "ロールを作成",
  "createB": "名前（必要に応じて説明も）を入力してロールを追加します。最初は空の状態なので、下のマトリクスで機能にチェックを入れてください。",
  "toolsT": "マトリクスを絞り込む",
  "toolsB": "表示するロールを選び、機能名で検索し、グループを折りたたみ・展開して目的の行を見つけます。",
  "roleT": "ロールごとに1列",
  "roleB": "各ロールには、保有しているユーザー数が表示されます。ペンで名前や有効状態を編集し、コピーのアイコンですべての権限ごと複製し、ゴミ箱で誰も使っていないロールを削除します。",
  "cellT": "表示と編集",
  "cellB": "「閲覧」にチェックを入れるとその画面がロールに付与され、画面に「編集」がある場合はそれにチェックを入れると変更が許可されます。親へのチェックは、サブ権限には引き継がれません。",
  "noteT": "削除する前に",
  "noteB": "組み込みのロールは編集できますが削除できません。使用中のロールは、ユーザーを移動するまで残ります。変更は、各自が次にポータルを読み込んだときに反映されます。"
};

const dictionary = { ns: 'tourRoles', en, ko, vi, zh, fr, ja };
export default dictionary;
